import React from 'react';
import './index.scss';
import config from '../../utils/config';

const Footer = () => {
  const { trademark, legal, terms } = config.footer.copyright;
  return (
    <div className="page-footer">
    {trademark}
    </div>
  );
};

export default Footer;
